import React from 'react';
import { SetHostProps } from './SetHost.type';
import { useTranslation } from 'react-i18next';
import './SetHost.scss';
import wemeetClient from '@utils/wemeetClient';
import { BOOL, HostType } from '@tencent/wemeet-websdk-next';
import { openDialog } from '@component/dialog';

const SetHost: React.FC<SetHostProps> = ({ user }) => {
  const { t } = useTranslation();
  const onSetHost = () => {
    openDialog({
      title: t('设置主持人'),
      content: t('确定将{#nickname#}设置为主持人?', { nickname: user?.nickname ?? t('该成员') }),
      onOk: () => {
        if (user.id) {
          wemeetClient.hostCtrl.changeHost(user.id, HostType.host, BOOL.true).catch((err) => {
            // 成功的回调通过 HOST_CHANGED 的回调触发
            console.log('设置主持人失败:', err);
          });
        }
      },
      onCancel: () => {},
    });
  };
  return (
    <li className="set-host" onClick={onSetHost}>
      {t('设为主持人')}
    </li>
  );
};

export default SetHost;
